import React from 'react';

const Docs = () => {
  return <div>Docs Page</div>;
};

export default Docs;